import { RdProject } from '@neo.tax/rd/hooks';
import { ProjectPurposeImprovedAspect } from '@neo.tax/shared';

export const RD_PROJECT_PURPOSE_IMPROVED_ASPECTS = [
  ProjectPurposeImprovedAspect.Function,
  ProjectPurposeImprovedAspect.Performance,
  ProjectPurposeImprovedAspect.Quality,
  ProjectPurposeImprovedAspect.Reliability,
];

export const getRdProjectPurposeImprovedAspectsSet = (
  improvedAspects: RdProject['improvedAspects'],
): Set<ProjectPurposeImprovedAspect> => {
  if (!improvedAspects) {
    return new Set();
  }
  return new Set(
    RD_PROJECT_PURPOSE_IMPROVED_ASPECTS.filter((improvedAspect) => improvedAspects.includes(improvedAspect)),
  );
};
